function removeMarkers(element) {
  // console.log('removeMarkers element', element);

  const onInputs = element.querySelectorAll('input[type="hidden"][value="on"]');
  // console.log('removeMarkers onInputs.length', onInputs.length);

  const underscoreInputs = Array.prototype.filter.call(onInputs, el => el.name.startsWith('_'));
  // console.log('removeMarkers underscoreInputs.length', underscoreInputs.length);

  underscoreInputs.forEach(input => input.remove());
}

module.exports = { removeMarkers };
